import React from "react";
import { Box, Flex, Heading, HStack, Select, Spacer, Text } from "@chakra-ui/react";
import { DashboardShell } from "../report/DashboardShell";
export default class AnalyticsApp extends React.Component {
    constructor(prop) {
        super(prop);
        this.repors = new Map();
        prop.config.reporttypes.forEach((r) => {
        });
        this.state = {
            selectedreport: "",
            buildingreport: false,
            report: undefined
        };
    }
    render() {
        return (React.createElement(Box, { p: { base: 4, md: 6 }, maxW: "1200px", mx: "auto" },
            React.createElement(Flex, { align: "center", mb: 4, gap: 3, wrap: "wrap" },
                React.createElement(Box, null,
                    React.createElement(Heading, { size: "md" }, this.props.config.headertitle)),
                React.createElement(Spacer, null),
                React.createElement(HStack, null,
                    React.createElement(Text, { fontSize: "sm", color: "gray.600" }, "Report"),
                    React.createElement(Select, { placeholder: "Select Report", value: this.state.selectedreport, onChange: (e) => {
                            this.setState({ selectedreport: e.target.value, buildingreport: e.target.value ? true : false, report: undefined });
                            if (e.target.value) {
                                this.props.config.reportselected(e.target.value, (def) => {
                                    this.setState({ report: def, buildingreport: false });
                                });
                            }
                        }, w: { base: "220px", md: "280px" } }, Object.values(this.props.config.reporttypes).map((r) => (React.createElement("option", { key: r.id, value: r.id }, r.label)))))),
            this.state.report !== undefined && React.createElement(DashboardShell, { key: this.state.report.id, maxheight: this.props.maxheight, report: this.state.report })));
    }
}
